/**
 * Authority Page
 *
 * Page for managing a specific authority - shows details, employees, and allows
 * key rotation and employee management.
 */

import { useParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Alert,
} from '@mui/material';
import { ArrowBack as BackIcon } from '@mui/icons-material';
import { AuthorityManagement } from '../features/encryption/components/AuthoritySetup/AuthorityManagement';

export function AuthorityPage() {
  const { authorityId } = useParams<{ authorityId: string }>();
  const navigate = useNavigate();

  if (!authorityId) {
    return (
      <Alert severity="error">
        Keine Behörden-ID angegeben.
      </Alert>
    );
  }

  return (
    <Box>
      <Button
        startIcon={<BackIcon />}
        onClick={() => navigate(-1)}
        sx={{ mb: 2 }}
      >
        Zurück
      </Button>

      <AuthorityManagement authorityId={authorityId} />
    </Box>
  );
}
